import { FC, ReactNode } from 'react';
import { EasyField } from 'react-bootstrap-formutil';
import BaseAddress from 'components/forms/HomeAddress/ChnHomeAddress/BaseAddress';
import type { FormCheckType } from 'types/common';
import type { CustomerInfoKeyType } from 'types/customer';
import DeliveryCountry from '../components/DeliveryCountry';
import { BaseDeliveryAddressProps, DeliveryAddressTypeEnum } from '../type';

export interface CHNDeliveryAddressFormutil {
    delivery_state: string;
    delivery_city: string;
    delivery_district: string;
    delivery_detail: string;
    delivery_country: string;
    delivery_address_type: DeliveryAddressTypeEnum;
}

export interface CHNDeliveryAddressProps extends BaseDeliveryAddressProps {
    title?: ReactNode;
    legalResidenceCountry?: string;
}

/**
 * @description 获取邮寄地址对应的默认表单项字段的数组
 * @param sameDeliveryAndResidence same_delivery_and_residence，“我的邮寄地址与居住地址不同”对应的字段
 */
export function getFieldsOfCHNDeliveryAddress(
    sameDeliveryAndResidence: FormCheckType | undefined,
    needDeliveryAddressType: boolean = true
) {
    const baseFields: CustomerInfoKeyType[] =
        sameDeliveryAndResidence === '0'
            ? ['delivery_state', 'delivery_city', 'delivery_district', 'delivery_detail', 'delivery_country']
            : [];

    return needDeliveryAddressType ? baseFields.concat('delivery_address_type') : baseFields;
}

const CHN: FC<CHNDeliveryAddressProps> = ({ title = __('MAILING ADDRESS'), hasCountry, disabled, ...restProps }) => {
    return (
        <div className="chn-delivery-address-root">
            {title && <h3 className="open-title mt-4">{title}</h3>}
            {hasCountry && <DeliveryCountry $defaultValue="CHN" disabled={disabled} />}
            <BaseAddress prefix="delivery" disabled={disabled} hideMailAddress label={null} {...restProps} />
            <EasyField name="delivery_address_type" type="hidden" $defaultValue={DeliveryAddressTypeEnum.CHN} />
        </div>
    );
};

export default CHN;
